import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Popover, QRCode, Table, Tooltip } from "antd";
import axios from "axios";
import {
  PlusOutlined,
  DeleteOutlined,
  ExpandAltOutlined,
  ScheduleOutlined,
  QrcodeOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../../context";
import LOGO from "./../../../../../assets/tinyimg/logo.webp";
import _ from "lodash";
import MerchantEmployeeCreateCustomer from "./MerchantEmployeeCreateCustomer";
import MerchantEmployeeLayout from "../../../../layout/MerchantEmployeeLayout";
import MerchantEmployeeCheckoutService from "./MerchantEmployeeCheckoutService";
import MerchantEmployeeExtendService from "./MerchantEmployeeExtendService";

const MerchantEmployeeForCheckout = ({
  merchantOrderSaveList,
  activeServiceList,
  rerun,
  refresh,
  loading,
  setLoading,
}) => {
  const [search, setSearch] = useState("");
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openExtendDrawer, setOpenExtendDrawer] = useState(false);
  const [openCheckoutDrawer, setOpenCheckoutDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction #",
      dataIndex: "transaction_id",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Started",
      dataIndex: "started_date",
      render: (text, record) => (
        <p>
          {moment(`${text.replace(" ", "T")}.000000Z`)
            .utc()
            .format("LT")}
        </p>
      ),
    },
    {
      title: "Ended",
      // dataIndex: "ended_date",
      render: (text, record) => (
        <p>
          {/* {console.log("TEXT:", text)} */}
          {text.service_type === "duration"
            ? moment(`${text.ended_date.replace(" ", "T")}.000000Z`)
                .utc()
                .format("LT")
            : "--:---:---"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 150,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 150 }}>
          {text.service_type !== "one-time" && (
            <Tooltip title="Order QR" placement="bottom">
              <Popover
                overlayInnerStyle={{
                  padding: 0,
                }}
                content={
                  <QRCode
                    value={`${import.meta.env.VITE_API_SITE_URL}${
                      userData.data.usersmerchantemployee.merchant_user_id
                    }/${userData.data.usersmerchantemployee.merchant_uid}/${
                      text.transaction_id
                    }`}
                    bordered={false}
                    style={{
                      marginBottom: 16,
                    }}
                    icon={LOGO}
                    errorLevel="Q"
                  />
                }
              >
                <Button
                  type="dashed"
                  shape="circle"
                  icon={<QrcodeOutlined />}
                  style={{ marginRight: 5 }}
                  size="small"
                />
              </Popover>
            </Tooltip>
          )}

          {text.service_type === "duration" && (
            <Tooltip title="Extend">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setOpenExtendDrawer(true);
                }}
                icon={<ExpandAltOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Tooltip>
          )}

          <Tooltip title="Checkout">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenCheckoutDrawer(true);
              }}
              icon={<ScheduleOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteCustomerService();
    }, 2000);
  };

  const handleDeleteCustomerService = () => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    axios
      .post("user/merchant/delete-avail-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete service successfully.");
          setTimeout(() => {
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search transaction # or name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenDrawer(true)}
            style={{ marginRight: 5 }}
          >
            Add
          </Button>

          <Button type="default" icon={<SyncOutlined />} onClick={refresh}>
            Refresh
          </Button>
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantEmployeeCreateCustomer
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          activeServiceList={activeServiceList}
        />
      )}
      {openExtendDrawer && (
        <MerchantEmployeeExtendService
          open={openExtendDrawer}
          close={() => setOpenExtendDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          selectedData={selectedData}
        />
      )}

      {openCheckoutDrawer && (
        <MerchantEmployeeCheckoutService
          open={openCheckoutDrawer}
          close={() => setOpenCheckoutDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Delete this transaction?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </>
  );
};

export default MerchantEmployeeForCheckout;
